module.exports = __webpack_public_path__ + "img/Infografis_EN_03.8bff6629.jpg";